import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/pro-hosty',
      name: 'hosts',
      component: () => import(/* webpackChunkName: "hosts" */ './pages/Hosts.vue')
    },
    {
      path: '/fotogalerie',
      name: 'fotogallery',
      component: () => import(/* webpackChunkName: "fotogalery" */ './pages/Fotogalery.vue')
    }
  ]
})
